import { Product } from '@shared/generated/graphql';
import { compact, zip } from 'lodash';

type ChatSuggestionProduct =
  | Product.CALLS
  | Product.COVER
  | Product.ORDERS
  | Product.QUOTES
  | Product.TRACK;

export type ChatSuggestion = {
  label: string;
  message: string;
  product: Product;
};

export const MAX_CHAT_SUGGESTIONS = 4;

const CHAT_SUGGESTIONS_BY_PRODUCT: Record<
  ChatSuggestionProduct,
  Omit<ChatSuggestion, 'product'>[]
> = {
  [Product.QUOTES]: [
    {
      label: 'Historical pricing for a lane',
      message: 'Show me historical pricing for a lane: ',
    },
    {
      label: 'Run the quote simulator',
      message: 'Run the quote simulator on a lane: ',
    },
  ],
  [Product.COVER]: [
    {
      label: 'Loads still needing coverage',
      message: 'Which loads still need to be covered this week?',
    },
    {
      label: 'Recommend carriers for a lane',
      message: 'Recommend carriers for a lane: ',
    },
  ],
  [Product.TRACK]: [
    {
      label: 'Loads running late today',
      message: 'Which loads are running late today?',
    },
    {
      label: 'Status of a load',
      message: "What's the latest status on load ",
    },
  ],
  [Product.ORDERS]: [
    {
      label: 'Build this order',
      message: 'Build this order: ',
    },
    {
      label: 'Set up automated order entry',
      message: 'Help me set up automated order entry for a new customer',
    },
  ],
  [Product.CALLS]: [
    {
      label: 'Call a carrier for a status update',
      message: 'Call the carrier for a status update on load ',
    },
  ],
};

const CHAT_SUGGESTION_PRODUCT_ORDER: ChatSuggestionProduct[] = [
  Product.QUOTES,
  Product.COVER,
  Product.TRACK,
  Product.ORDERS,
  Product.CALLS,
];

export function getChatSuggestions(
  organizationProducts: Product[]
): ChatSuggestion[] {
  const suggestionsPerProduct = CHAT_SUGGESTION_PRODUCT_ORDER.filter(
    (product) => organizationProducts.includes(product)
  ).map((product) =>
    CHAT_SUGGESTIONS_BY_PRODUCT[product].map((suggestion) => ({
      ...suggestion,
      product,
    }))
  );
  return compact(zip(...suggestionsPerProduct).flat()).slice(
    0,
    MAX_CHAT_SUGGESTIONS
  );
}
